export default __webpack_public_path__ + "static/media/lightSensor.cd1726a0.svg";